module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"add":"Extra","shipping-panel-block-title":"Regular Timetable","holiday-add-ship-notice":"(Flexible adding ship on holidays)","actual-schedule-desc":"The actual schedule is based on on-site schedule"},"zh-TW":{"add":"加開","shipping-panel-block-title":"固定船班時刻表","holiday-add-ship-notice":"(例假日機動加開航班)","actual-schedule-desc":"實際航班表依現場為主"}}')
  delete Component.options._Ctor
}
